"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceType = void 0;
var DataSourceType;
(function (DataSourceType) {
    DataSourceType["PARTICIPANT"] = "PARTICIPANT";
    DataSourceType["PARTICIPANT_TEAMS"] = "PARTICIPANT_TEAMS";
    DataSourceType["WORK_LOCATION"] = "WORK_LOCATION";
    DataSourceType["WORK_ORDER"] = "WORK_ORDER";
    DataSourceType["ADVANCED"] = "ADVANCED";
    DataSourceType["BASIC"] = "BASIC";
    DataSourceType["PARTICIPANT_ROLES"] = "PARTICIPANT_ROLES";
})(DataSourceType = exports.DataSourceType || (exports.DataSourceType = {}));
//# sourceMappingURL=dataSourceType.js.map